const locale = {
  appName: 'Kiness',
  tagline: '가족을 연결합니다',
  signIn: '로그인',
  signUp: '회원가입',
  signOut: '로그아웃',
  email: '이메일',
  password: '비밀번호',
  name: '이름',
  facilityCode: '시설 코드',
  facilityCodeHint: '요양 시설에 이 코드를 문의하세요',
  noAccount: '계정이 없으신가요?',
  haveAccount: '이미 계정이 있으신가요?',
  signingIn: '로그인 중…',
  creatingAccount: '계정 생성 중…',
  loginError: '로그인할 수 없습니다 — 이메일과 비밀번호를 확인하세요',
  registerError: '계정을 만들 수 없습니다 — 다시 시도해 주세요',
  welcomeBack: '다시 오신 것을 환영합니다',
  welcomeNew: '케어 커뮤니티에 참여하세요',
  selectResident: '이 업데이트는 누구에 대한 것인가요?',
  updatePlaceholder: '오늘 {name}은(는) 어떠신가요?',
  addPhoto: '사진 추가',
  postUpdate: '업데이트 게시',
  posting: '게시 중…',
  postSuccess: '게시 완료 — 가족에게 알림이 전송됩니다',
  postError: '게시할 수 없습니다 — 연결을 확인하고 다시 시도하세요',
  yourLovedOne: '소중한 분',
  familyFeed: '가족 피드',
  tabFeed: '피드',
  tabRecord: '기록',
  tabCalendar: '일정',
  tabPhotos: '사진',
  noUpdates: '아직 업데이트가 없습니다 — 잠시 후 다시 확인해 주세요',
  pullRefresh: '아래로 당겨 새로고침',
  refreshing: '새로고침 중…',
  admin: '관리',
  dashboard: '대시보드',
  residents: '입소자',
  familyLinks: '가족 연결',
  staff: '직원',
  facility: '시설',
  residentsCount: '입소자',
  familyLinked: '연결된 가족',
  updatesToday: '오늘의 업데이트',
  addResident: '입소자 추가',
  editResident: '수정',
  removeResident: '삭제',
  firstName: '이름',
  lastName: '성',
  room: '방',
  save: '저장',
  cancel: '취소',
  addFamilyEmail: '이메일로 가족 추가',
  addStaffEmail: '이메일로 직원 추가',
  staffAdd: '추가',
  staffCount: '직원 {count}명',
  relationship: '관계',
  inviteSent: '초대 준비 완료 — 시설 코드로 등록할 수 있습니다',
  loading: '로딩 중…',
  installTitle: 'Kiness를 홈 화면에 추가',
  installBody: '소중한 분의 소식을 빠르게 확인하세요',
  installButton: '홈 화면에 추가',
  installDismiss: '나중에',
  language: '언어',
  chooseLanguage: '언어를 선택하세요',
  chooseLanguageSub: '选择您的语言',
  changeLanguageHint: '지구본 아이콘으로 언제든지 변경할 수 있습니다',
  english: 'English',
  chinese: '中文',
  newUpdate: '새 업데이트',
  from: '작성',
  roomLabel: '방',
  confirmRemove: '이 입소자를 삭제할까요?',
  staffPostTitle: '업데이트 게시',
  adminTitle: '시설 대시보드',
  linkedFamily: '연결된 가족',
  pendingInvite: '대기 중인 초대',
  noResidents: '아직 입소자가 없습니다 — 첫 입소자를 추가하세요',
  noStaff: '아직 직원이 없습니다',
  photoOptional: '사진 (선택)',
  dashboardSettingUp: '대시보드를 준비하는 중…',
  dashboardEmptyHint: '첫 입소자를 추가하여 시작하세요',
};

export default locale;
